// Customizable Area Start
import React, { ChangeEvent } from "react";
import {
  Box,
  Button,
  Card,
  IconButton,
  TextField,
  Popover,
  ListItemText,
  MenuItem,
  Typography,
  Modal,
  Snackbar,
  Divider,
  CircularProgress,
  Menu,
  FormControl,
  Select,
} from "@material-ui/core";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import SmartphoneOutlinedIcon from '@material-ui/icons/SmartphoneOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MuiAlert from "@material-ui/lab/Alert";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { withStyles, createStyles, Theme, styled } from "@material-ui/core/styles";
import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";
import MessagesController from "./MessagesController.web";
import PersonIcon from "@material-ui/icons/Person";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import CreateIcon from "@material-ui/icons/Create";
import ArchiveOutlinedIcon from "@material-ui/icons/ArchiveOutlined";
import SimpleMessageVariablesDropdown from "./SimpleMessageVariablesDropdown.web";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import CallIcon from "@material-ui/icons/Call";
// import PersonIcon from "@material-ui/icons/Person";
import MarkunreadIcon from "@material-ui/icons/Markunread";
import BlockIcon from "@material-ui/icons/Block";
import DeleteIcon from "@material-ui/icons/Delete";
import { ListItemIcon } from "@material-ui/core";
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import {
  EverybrandIcon,
  aIcon,
  allMessagesIcon,
  camera,
  chatCircle,
  chatIcon,
  chatWhite,
  closeIcon,
  directPostCircle,
  directPostIcon,
  directWhite,
  document,
  folderIcon,
  group_plus,
  icon_info,
  search_icon,
  sendMessageIcon,
  textCircle,
  textIcon,
  textWhite,
  whiteFolder,
} from "./assets";
import { pinIcon } from "../../notifications/src/assets";
import { conversationType } from "./constants";
import { Formik } from "formik";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { handleAndConditions } from "../../../components/src/CommonFunctions";
import { MessageOption } from "./MessageOptions.web";
import moment from "moment";
import LaptopIcon from '@material-ui/icons/Laptop';
import { addPlusIcon } from "../../settings2/src/assets";
import { backArrow, ChatNavIcon } from "../../dashboard/src/assets";
import CustomLoader from "../../../components/src/CustomLoader.web";
import { processMessageVariables, MessageContext as SimpleMessageContext } from '../../utilities/src/MessageVariableProcessor';

const webStyles = {
  phoneInput: {
    width: "100%",
    height: "56px",
    fontWeight: 400,
    fontSize: "12px !importent",
    color: "#64748B",
    // border:"1px solid #FFC629",
    margin: "10px 0",
  },
  phoneInput1: {
    width: "310px",
    height: "56px",
    border: "1px solid #CBD5E1",
    borderRadius: "8px",
    fontFamily: "Inter",
    fontWeight: 400,
    fontSize: "16px !important",
  },
};

const StyledMenuItemFilter = styled(MenuItem)({
  "&:hover": {
    backgroundColor: "#000",
    color: "#FFF",
  },
  "&.Mui-selected": {
    backgroundColor: "#000 !important",
    color: "#FFF !important",
  },
  "&.Mui-selected:hover": {
    backgroundColor: "#000 !important",
    color: "#FFF !important",
  },
});

const validation_Schema_newcontact = yup.object({
  first_name: yup
    .string()
    .required("First Name is required")
    .matches(/^[a-zA-Z]+$/, "Only alphabets are allowed"),
  last_name: yup
    .string()
    .required("Last Name is required")
    .matches(/^[a-zA-Z]+$/, "Only alphabets are allowed"),
  email: yup.string().email("Invalid email address"),
  phone: yup
    .string()
    .required("Phone number is required")
    .min(10, "Must be at least 10 digits"),
});

export class Messages extends MessagesController {
  isEmojiOnlyMessage(messageBody: any) {
    if (!messageBody) return false;
    const plainText = String(messageBody)
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim();
    if (!plainText) return false;

    const emojiOnlyRegex = /^(?:\s|[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}])+$/u;
    return emojiOnlyRegex.test(plainText);
  }

  getProfilePic(url: any, classes: any, input?: boolean) {
    if (url) {
      return <img src={url} alt=""  style={{ height: "28px", width: "28px" }}/>;
    } else if(input){
      return <PersonIcon style={{ height: "28px", width: "28px" }} />
    } 
    else {
      return <div className={classes.conversationImage}>
        <PersonIcon style={{ height: "28px", width: "28px" }} />
      </div>
    }
  }
  
  getFirstName(firstName: any) {
    if (firstName) {
      return firstName;
    } else {
      return "Name";
    }
  }

  getFullName(firstName: string | null, lastName: string | null) {
    if (firstName) {
      return lastName ? firstName + " " + lastName : firstName;
    } else {
      return "Name";
    }
  }

  getFormattedNumber(userPhone: string) {
    if(userPhone){
      return (
        userPhone.slice(0, 1) +
        userPhone.slice(1, 4) +
        "-" +
        userPhone.slice(4, 7) +
        "-" +
        userPhone.slice(7)
      );
    }
    return "-"
    
  }

  getLatestText(text: any) {
    if (text && text.toString().trim()) {
      const textWithoutTags = text.toString()?.replace(/<[^>]*>?/gm, '').trim();
      if (textWithoutTags.length > 15) {
        return textWithoutTags.substring(0, 15) + "...";
      } else {
        return textWithoutTags;
      }
    }
    return ""
  }
  getDateForSorting(date: any) {
    if (date) {
      if (date.includes('pinned')) {
        return "Pinned";
      }
      const currentDate = new Date();
      const inputDate = new Date(date);
      const isToday = currentDate.toDateString() === inputDate.toDateString();
      const isYesterday = new Date(currentDate.setDate(currentDate.getDate() - 1)).toDateString() === inputDate.toDateString();
  
      if (isToday) {
        return "Today";
      }
      if (isYesterday) {
        return "Yesterday";
      }
  
      return inputDate.toLocaleDateString();
    } else {
      return "";
    }
  }

  getDate(date: any) {
    if (date) {
      return new Date(date).toLocaleDateString();
    } else {
      return "";
    }
  }
  

  getCurrentTime() {
    let date = new Date();
    let hours = date.getHours();
    let minutes: any = date.getMinutes();
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    let timeString = hours + ":" + minutes + " " + ampm;
    return timeString;
  }

  getStyle(type: string) {
    if (this.state.chatType === type) {
      return { background: "black", color: "white" };
    }
  }
  
  getStyleForImage(type: string){
    if(this.state.chatType === type){
      return {filter: "invert(100%) brightness(10)"}
    }
  }

  getIcon(type: string) {
    if (this.state.chatType === type) {
      return true;
    } else {
      return false;
    }
  }

  renderContacts(classes: any, contacts: any) {
    return (
      <>
        {contacts.map((contact: any) => {
          return (
            <div
              data-test-id="contactButton"
              className={classes.singleConversation}
              key={contact.id}
              onClick={() => this.hanldeUserContact(contact)}
            >
              <div className={classes.conversationContainer}>
                {this.getProfilePic(contact.attributes?.profile_pic_url, classes)}
                <div className={classes.conversationDetails}>
                  <div className={classes.nameText}>
                    {this.getFirstName(contact.attributes?.first_name) +
                      " " +
                      this.getFirstName(contact.attributes?.last_name)}
                  </div>
                  <div className={classes.msgTxt}>
                    {this.getLatestText(contact.attributes?.full_phone_number)}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </>
    );
  }
  getTextCircle(type: string) {
    if (type === "SmsContact") {
      return <img style={{ paddingBottom: "10px" }} src={textCircle} alt="" />;
    }
    if (type === "EmailAccount") {
      return (
        <img style={{ paddingBottom: "10px" }} src={directPostCircle} alt="" />
      );
    }
    if (type === "ChatContact") {
      return <img style={{ paddingBottom: "10px" }} src={chatCircle} alt="" />;
    }
  }
  renderCoversations(classes: any) {
    
    return (
      <>
        {this.state.conversationNewData.map((item: any, index: number) => {
          console.log("conversationNewData",this.state.conversationNewData);
          
          return (
            <div key={index} data-test-id="converstaionDiv">
              {item.contacts?.length > 0 && (
                <div className={classes.flexSB}>
                  <span className={classes.filterText}>
                    {this.getDateForSorting(item.date)}
                  </span>
                  <hr className={classes.dateDivider} />
                </div>
              )}

              {item.contacts?.map((contact: any, contactIndex: number) => {
                console.log("contact 22323",contact);
                
                return (
                  <div
                    data-test-id="converstaionButton"
                    className={classes.singleConversation}
                    style={
                      this.state.selectedConversation?.id === contact.id
                        ? {
                          backgroundColor: "rgba(217,217,217,0.2)",
                          borderRadius: "6px",
                        }
                        : {}
                    }
                    key={`${contact.id}-${contactIndex}-${index}`}
                    onClick={() => {
                      this.getConversation(contact);
                      this.handleInfoModalChange();
                    }}
                  >
                    <div className={classes.conversationContainer}>
                      <div className={classes.conversationImage}>
                        {this.getProfilePic(undefined, classes)}
                      </div>

                      <div className={classes.conversationDetails}>
                    <div className={classes.nameText}>
  {contact.customer
    ? this.getFirstName(contact.customer.first_name)
    : (contact.participants?.find(
        (p: any) => String(p.id) !== String(contact.account_id)
      )?.attributes?.business_name || "Unknown")}
</div>

                        <div className={classes.msgTxt}>
                          {contact.last_message?.content
                            ? this.getLatestText(contact.last_message.content)
                            : this.getTextCircle(contact.kind)}
                        </div>

                        <div className={classes.dateText}>
                          {this.getDate(
                            contact.last_message?.created_at || contact.created_at
                          )}
                        </div>
                      </div>
                    </div>

                    <div>
                      <div className={classes.rightSection}>
                        <IconButton
                          data-test-id="iconBtnPopover"
                          className={classes.postSettingsBtn}
                          onClick={(e) => this.handleMessageOptions(e, contact)}
                        >
                          <MoreVertIcon />
                        </IconButton>
                      </div>

                      {this.state.messageOptionsPopover && (
                        <MessageOption
                          selectedMessage={this.state.selectedConversationForPopover}
                          folders={this.state.userFolders}
                          closePopover={this.handleMessagePopoverClose}
                          classes={classes}
                          isPopoverVisible={this.state.messageOptionsPopover}
                          callBackAfterAPI={this.getUserChats}
                          handleReply={this.handleMessagePopoverReply}
                          handleApiResponse={this.handleOptionsApiResponse}
                          handleClosePopover={this.handleClosePopover}
                        />
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </>
    );
  }

  formatPhoneNumber = (phone: string) => {
    if (!phone) return "";
  
    try {
      const phoneNumber = parsePhoneNumberFromString(phone);
      if (phoneNumber) {
        return phoneNumber.formatInternational();
      }
      return phone;
    } catch {
      return phone;
    }
  };
  render() {
    const open = Boolean(this.state.anchorEll);

    const { classes }: any = this.props;

    const automationOpen = Boolean(this.state.automationModal);


    const renderAddContact = () => {
      return <Box
      className={classes.newContectModalBox}
      data-test-id="newContactModalMainBox"
    >
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
        }}
        validationSchema={validation_Schema_newcontact}
        onSubmit={(values) => {
          this.addContacts(values);
        }}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values,
          handleSubmit,
        }) => (
          <>
            <Typography className={classes.addnewconH}>
              Add Contact
            </Typography>
            <Box>
              <Typography className={classes.inputLable}>
                First Name*
              </Typography>
              <TextField
                variant="outlined"
                className={classes.addNewContectInput}
                name="first_name"
                data-test-id="secondStepInput"
                placeholder="Add Your Name"
                value={values.first_name}
                onChange={handleChange("first_name")}
                onBlur={handleBlur("first_name")}
              />
              {handleAndConditions(
                touched.first_name,
                errors.first_name,
                <Typography className={classes.errorMsg}>
                  {errors.first_name}
                </Typography>
              )}
              <Typography className={classes.inputLable}>
                Last Name*
              </Typography>
              <TextField
                variant="outlined"
                className={classes.addNewContectInput}
                name="last_name"
                data-test-id="secondStepInput"
                placeholder="Add Your Name"
                value={values.last_name}
                onChange={handleChange("last_name")}
                onBlur={handleBlur("last_name")}
              />
              {handleAndConditions(
                touched.last_name,
                errors.last_name,
                <Typography className={classes.errorMsg}>
                  {errors.last_name}
                </Typography>
              )}
              <Typography className={classes.inputLable}>
                Email
              </Typography>
              <TextField
                variant="outlined"
                className={classes.addNewContectInput}
                name="email"
                data-test-id="secondStepInput"
                placeholder="Add Your Name"
                value={values.email}
                onChange={handleChange("email")}
                onBlur={handleBlur("email")}
                autoComplete="off"
              />
              {handleAndConditions(
                touched.email,
                errors.email,
                <Typography className={classes.errorMsg}>
                  {errors.email}
                </Typography>
              )}
              <Typography className={classes.inputLable}>
                Mobile Number*
              </Typography>
              <Box style={{ padding: "5px 0" }}>
                <PhoneInput
                  data-test-id="phone"
                  country={"us"}
                  value={values.phone}
                  onChange={handleChange("phone")}
                  onBlur={handleBlur("phone")}
                  placeholder="Enter Phone Number"
                  inputStyle={webStyles.phoneInput}
                  specialLabel={""}
                />
              </Box>
              {handleAndConditions(
                touched.phone,
                errors.phone,
                <Typography className={classes.errorMsg}>
                  {errors.phone}
                </Typography>
              )}
              <Button
                onClick={() => handleSubmit()}
                className={classes.addBtn}
                variant="contained"
                data-test-id="addContact"
                disabled={this.state.isAddingContact}
                startIcon={this.state.isAddingContact ? <CircularProgress size={20} color="inherit" /> : null}
              >
                {this.state.isAddingContact ? "ADDING..." : "ADD CONTACT"}
              </Button>
              <Button
                onClick={this.closeNewContactModal}
                className={classes.backBtn}
                variant="contained"
              >
                Back
              </Button>
            </Box>
          </>
        )}
      </Formik>
    </Box>
    }

    const renderCameraDocAuto = () => {
      return <Box className={classes.docCameraAutoContainer}>
      <img src={document} alt="" />
      <label
        htmlFor="fileAttachments"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <img
          src={camera}
          alt=""
          style={{ marginLeft: "11px", cursor: "pointer", width:'24px' }}
        />
      </label>
      <input
        data-test-id="fileAttachments"
        id="fileAttachments"
        type="file"
        accept="image/*"
        style={{ display: "none" }}
        onChange={this.handleCameraClick}
      />
      <img
        src={aIcon}
        alt=""
        style={{ marginLeft: "11px", cursor: "pointer" }}
        data-test-id="automationBtn"
        onClick={(e) => this.handleAutomationClick(e)}
      />
    </Box>
    }

    const renderAddNewMessageModal = () => {
      return (
        <Box className={classes.addNewMessageContainer}>
          <Box className={classes.flexSB}>
            <Typography className={classes.fromText}>
              New message from:{" "}
              <br className={classes.breakOnMobile}/>
              <p className={classes.businessNameText}>
                {this.state.userDetails.attributes?.business_name}
              </p>
            </Typography>{" "}
            <IconButton onClick={this.closeNewMssage} className={classes.crossIcon}>
              <img src={closeIcon} alt="" />
            </IconButton>
          </Box>
          <hr className={classes.messageDivider} />
          <Typography className={classes.infoText1}>
            Send to :
          </Typography>
          <TextField
            onChange={(e) => this.getContacts(e.target.value)}
            className={classes.inputFieldMessages}
            InputProps={{
              classes: { input: classes.inputName },
            }}
            placeholder="First and Last Name"
            fullWidth
            data-test-id="firstNameInput"
            value={this.state.contactSearchQuery ?? this.state.selectedContact?.attributes?.first_name ?? ""}
          />
          {this.state.showContcatCard ? (
            <Card className={classes.contactsCard}>
              {this.renderContacts(classes, this.state.userContacts)}
            </Card>
          ) : null}
          <TextField
            className={clsx(classes.inputFieldMessages, classes.phoneFieldMessage)}
            InputProps={{
              classes: { input: classes.input },
            }}
            placeholder="Mobile Number"
            fullWidth
            value={this.state.selectedContact?.attributes?.full_phone_number || ""}
          />
          <Box className={classes.countryPhoneNumber}>
           <PhoneInput
              country={"us"}
              value={this.state.selectedContact?.attributes?.full_phone_number || ""}
              specialLabel={""}
              data-test-id="phoneInput"
              inputProps={{
                id: "fullPhoneNumber",
                name: "fullPhoneNumber",
                ["data-test-id"]: "phoneInput",
              }}
              inputStyle={webStyles.phoneInput1}
            />

          </Box>
          <div className={classes.newContact} style={Object.keys(this.state.selectedContact).length !== 0 ? {display: 'none'}: {}}>
            {" "}
            <Button
              data-test-id="contactModalBoxName"
              className={classes.flexSB}
              style={{ width: "97%", position: "relative" }}
              onClick={this.openNewContactModal}
            >
              <Box
                data-test-id="contactModalClick"
                className={classes.infoText3}
              >
                <img src={group_plus} alt="" />
                <Typography style={{fontWeight: 600, textTransform: "none"}}>New Contact</Typography>
                <div className={classes.itagBtn}>
                  <img src={icon_info} alt="" />
                </div>
              </Box>
            </Button>
          </div>
          <Button
            id="submit"
            variant="contained"
            type="submit"
            disableElevation
            className={classes.addContactButton}
            data-test-id="addContactButton"
          >Continue
          </Button>
        </Box>
      )
    }

    const renderLeftSide = () => {
      return <Box className={classes.leftBox}>
      <div>
      <Box>
        <Typography
          component="div"
          className={classes.infoText2}
          style={{ ...this.getStyle(conversationType[0])}}
          data-test-id="allMsgBtn"
          onClick={() => this.handleMessageCategory(conversationType[0], allMessagesIcon )}
        >
          <div style={{ display: "flex", marginRight: "50px" }}>
            <img className={classes.imageIcons} style={{...this.getStyleForImage(conversationType[0])}} src={ ChatNavIcon } alt="" />{" "}
            ALL MESSAGES{" "}
          </div>
        </Typography>
        <Typography component="div" className={classes.infoText2} data-test-id="textBtn" style={{ ...this.getStyle(conversationType[1])}}
          onClick={() => this.handleMessageCategory(conversationType[1], textCircle)} 
          >
          <div style={{ display: "flex", marginRight: "50px" }}>
            <img className={classes.imageIcons} src={ textIcon } alt="" style={{...this.getStyleForImage(conversationType[1])}} />{" "}
            Text{" "}
          </div>
          <img src={textCircle} alt="" style={{ marginRight: "16px" }} />
        </Typography>
        <Typography
          component="div"
          className={classes.infoText2}
          data-test-id="chatBtn"
          style={{ ...this.getStyle(conversationType[2])}}
          onClick={() => this.handleMessageCategory(conversationType[2], chatCircle)}
        >
          <div style={{ display: "flex", marginRight: "50px",gap:"10px" }}>
            <LaptopIcon />
            Chat{" "}
          </div>
          <img src={chatCircle} alt="" style={{ marginRight: "18px" }} />
        </Typography>
        <Typography
          component="div"
          className={classes.infoText2}
          data-test-id="directPostBtn"
          style={{ ...this.getStyle(conversationType[3])}}
          onClick={() => this.handleMessageCategory(conversationType[3], directPostCircle)}
        >
          <div style={{ display: "flex" }}>
            <img
              className={classes.imageIcons}
              src={directPostIcon}
              alt=""
              style={{...this.getStyleForImage(conversationType[3])}}
            />{" "}
            Direct Post{" "}
          </div>
          <img
            style={{ marginRight: "19px" }}
            src={directPostCircle}
            alt=""
          />
        </Typography>
      </Box>
      <Box className={classes.folderContainer}>
        <Typography
          className={classes.infoText1}
          style={{ marginLeft: "17px", paddingTop: 0, paddingBottom: "10px" }}
        >
          ASSIGNED FOLDER
        </Typography>
        <div className={classes.folerAndFolderCreateButtonContainer}>
          <Box className={classes.scrollFolderBox}>
            {this.state.userFolders.map((folder: any) => {
              return (
                <Typography
                  className={classes.infoTextFolder}
                  key={folder.id}
                >
                  <div style={{ display: "flex" }}>
                    <img
                      className={classes.imageIcons}
                      src={folderIcon}
                      alt=""
                    />{" "}
                    {folder.attributes?.name}
                  </div>
                  <IconButton
                    className={classes.postSettingsBtn}
                    style={{ marginLeft: "4px" }}
                    onClick={(e) => this.handleClickPopOver(e, folder)}
                    data-test-id="threeDotIconfolders"
                    aria-label="post-settings"
                  >
                    <MoreVertIcon />
                  </IconButton>
                  <Popover
                    id="simple-popover"
                    open={open}
                    anchorEl={this.state.anchorEll}
                    onClose={this.handleClosePopOver}
                    anchorOrigin={{
                      vertical: "center",
                      horizontal: "center",
                    }}
                    transformOrigin={{
                      vertical: "center",
                      horizontal: "right",
                    }}
                    classes={{
                      paper: classes.popOverPaper,
                    }}
                  >
                    <StyledMenuItem
                      className={classes.folderList}
                      data-test-id="editFolder"
                      onClick={() => {
                        this.openEditFolderModal();
                      }}
                    >
                      <ListItemText
                        style={{ paddingLeft: "40px" }}
                        primary={
                          <span
                            style={{
                              fontFamily: "Inter",
                              textAlign: "center",
                            }}
                          >
                            Edit
                          </span>
                        }
                      />
                    </StyledMenuItem>
                    <StyledMenuItem
                      data-test-id="deleteFolderBtn"
                      className={classes.folderList}
                      onClick={() => {
                        this.handleDeleteFolder();
                      }}
                    >
                      <ListItemText
                        style={{ paddingLeft: "40px" }}
                        primary={
                          <span style={{ fontFamily: "Inter" }}>
                            Delete
                          </span>
                        }
                      />
                    </StyledMenuItem>
                    <StyledMenuItem
                      className={classes.folderList}
                      data-test-id="reassignBtn"
                      onClick={() => {
                        this.openModal();
                      }}
                    >
                      <ListItemText
                        style={{ paddingLeft: "40px" }}
                        primary={
                          <span style={{ fontFamily: "Inter" }}>
                            Re-assign
                          </span>
                        }
                      />
                    </StyledMenuItem>
                  </Popover>
                </Typography>
              );
            })}
          </Box>
          <div className={classes.btnContainer}>
            <Button
              variant="contained"
              data-test-id="createFolderBtn"
              className={classes.createFolderBtn}
              onClick={() => this.createUserFolder()}
            >
              <img
                className={classes.imageIcons}
                style={{ paddingRight: "15px" }}
                src={whiteFolder}
                alt=""
              />{" "}
              <span
                style={{
                  paddingBottom: "5px",
                  paddingTop: "5px",
                  fontSize: "15px",
                }}
              >
                Create Folder
              </span>
            </Button>
          </div>
        </div>
      </Box>
      </div>
      <div className={classes.bottomleft}>
        <Link to="/settings">
          <Button
            startIcon={
              <SettingsOutlinedIcon className={classes.settingsIcon} />
            }
            fullWidth
            className={clsx(
              classes.buttonSettings,
              classes.textCapitalize
            )}
          >
            Settings
          </Button>
        </Link>
        <Typography className={classes.everyBrandLogo} gutterBottom>
          <img src={EverybrandIcon} alt="" />
        </Typography>
      </div>
    </Box>
    }

    const renderCenterSide = () => {
      return <Box className={classes.centerBox}>
        <Card className={classes.messageCard}>
          <div className={classes.flexSB} style={{ alignItems: "center" }}>
            {" "}
            <div className={classes.searchContainer}>
              <input
                placeholder="Search"
                value={this.state.searchText}
                className={classes.searchFieldTeammate}
                style={{ marginTop: "0px" }}
                onChange={(e) => {
                  const value = e.target.value;

                  this.setState({
                    searchText: value,
                  });

                  this.searchUsersApi(value);
                  this.searchCustomersApi(value);
                }}
              />

              {this.state.searchText.length > 0 &&
                (this.state.searchUsers.length > 0 ||
                  this.state.searchCustomers.length > 0) && (
                  <div className={classes.searchSuggestion}>

                    {/* Accounts API */}
                    {this.state.searchUsers.map((item: any) => (
                      <div
                        key={`user-${item.id}`}
                        className={classes.searchSuggestionItem}
                        onClick={() => this.handleSearchUserClick(item)}
                      >
                        <div className={classes.conversationImage}>
                          {this.getProfilePic(undefined, classes)}
                        </div>

                        <div className={classes.userInfo}>
                          <div className={classes.userName}>
                            {item.attributes.full_name ||
                              item.attributes.first_name}
                          </div>

                          <div className={classes.userSubTitle}>
                            +{item.attributes.country_code} {item.attributes.phone_number}
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Customers API */}
                    {this.state.searchCustomers.map((item: any) => (
                      <div
                        key={`customer-${item.id}`}
                        className={classes.searchSuggestionItem}
                        onClick={() => this.handleSearchUserClick(item)}
                      >
                        <div className={classes.conversationImage}>
                          {this.getProfilePic(undefined, classes)}
                        </div>

                        <div className={classes.userInfo}>
                          <div className={classes.userName}>
                            {item.first_name}
                          </div>

                          <div className={classes.userSubTitle}>
                            {item.phone}
                          </div>
                        </div>
                      </div>
                    ))}

                  </div>
                )}
            </div>
            {" "}
            <IconButton
              data-test-id="newMessageBtn"
              className={classes.addNewIconButton}
              style={{ padding: 0 }}
              onClick={() => {
                this.handleNewMessage();
              }}
            >
              <CreateIcon fontSize="medium" />
            </IconButton>
            {<Box className={classes.addNewChatMobileButton}>
              <img src={addPlusIcon} alt="" className={classes.yellowPlusIcon}
                onClick={() => { this.handleNewMessage() }} />
            </Box>}
          </div>
          <div className={classes.chatContainer}>
            <Typography className={classes.headingText}>
              {this.state.chatType}{" "}
              <img src={this.state.chatCircle} alt="" />
            </Typography>
            <div className={classes.filterBox}>
              {" "}
              <span className={classes.filterText}>Filter by:</span>{" "}
              <Box className={classes.filterInputModalBase}>
                <FormControl size="small" style={{ width: "100%" }}>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={this.state.selectedFilterName}
                    onChange={(e: any) => { this.setState({ selectedFilterName: e.target.value }) }}
                    variant="outlined"
                  >
                    <MenuItem value={"All Messages"} className={classes.filterMenuItem}>All Messages</MenuItem>
                    <MenuItem value={"Unread"} className={classes.filterMenuItem}>Unread</MenuItem>
                    <MenuItem value={"Read"} className={classes.filterMenuItem}>Read</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            {this.state.userDetails?.attributes?.phone_number && (
              <Box
                style={{
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#f5f7fb",
                  padding: "10px 16px",
                  borderRadius: "8px",
                  margin: "10px 0px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#2b2b2b",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                  border: "1px solid #e0e0e0",
                  width: "fit-content"
                }}
              >
                <span style={{ color: "#6b7280", marginRight: 6 }}>
                  Sending From:
                </span>

                <span style={{ fontWeight: 600, color: "#1976d2" }}>
                  {this.formatPhoneNumber(
                    this.state.userDetails.attributes.phone_number
                  )}
                </span>
              </Box>
            )}
            <div />
            <div
              className={classes.allConsversatitonBox}
              data-test-id="allConsversatitonBox"
            >
              <CustomLoader wrapperHeight="20vh" isLoading={this.state.isLoaderShow}>
                {this.renderCoversations(classes)}
              </CustomLoader>
            </div>
          </div>
        </Card>
      </Box>
    }

    const renderRightSide = () => {
      return <Box className={classes.rightBox}
      data-test-id="messageContainterRightBox"
    >
      <Card className={classes.messageCardRight}>
      <div className={classes.chatSection}>
      {this.state.isNewMessage && renderAddNewMessageModal()}

      {!this.state.isNewMessage && (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          
          {/* CASE 1: Bilkul pehli baar load hua hai (Nothing selected yet) */}
          {!this.state.hasSelectedAtLeastOnce && !this.state.newOrOldUserSelected && (
            <div className={classes.emptyContainer}>
              <div className={classes.emptyContent}>
                <div className={classes.emptyIconCircle}>
                  <ChatBubbleOutlineIcon className={classes.emptyIcon} />
                </div>
                <Typography className={classes.emptyTitle}>Select a conversation</Typography>
                <Typography className={classes.emptySubtitle}>
                  Choose a chat from the list to start messaging
                </Typography>
              </div>
            </div>
          )}

          {/* CASE 2: New User Modal (One time message) */}
          {this.state.newOrOldUserSelected && (
            <div className={classes.messageScreenUserOneTime}>
              <Box className={classes.flexSB}>
                <Typography className={classes.infoText1}>
                  New message from: {this.state.userDetails.attributes?.business_name}
                </Typography>
              </Box>
              <hr className={classes.messageDivider} />
              <Typography className={classes.infoText1}>Send to :</Typography>
              <Typography style={{ fontSize: "20px", fontWeight: "bold", marginTop: "20px" }}>
                {this.state.selectedConversation?.attributes?.first_name} {this.state.selectedConversation?.attributes?.last_name}
              </Typography>
              <hr className={classes.messageDivider} style={{ marginTop: '0px', marginBottom: "20px" }} />
              <Typography style={{ fontSize: "20px", fontWeight: 400 }}>{this.state.selectedConversation?.attributes?.full_phone_number}</Typography>
              <hr className={classes.messageDivider} style={{ marginTop: '0px' }} />
            </div>
          )}

          {/* CASE 3: Chat Screen (Ek baar select hone ke baad yahi dikhega) */}
          {this.state.hasSelectedAtLeastOnce && !this.state.newOrOldUserSelected && (
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              
              {/* TOP BAR: Always visible once a chat is opened */}
              <div className={classes.imageTop}>
                <Box
                  className={clsx(classes.topBarContainer, "contact-header-bar")}
                  style={
                    window.innerWidth < 950
                      ? { top: '33px  ' }
                      : undefined
                  }
                >
                  <Box className={classes.userRow}>
                    <Box className={classes.avatarCircle}>
                      {this.getProfilePic(this.state.selectedConversation?.attributes?.profile_pic_url, classes)}
                    </Box>
                          <Typography className={classes.phoneText}>
                            {this.state.selectedSearchUser?.full_name ||
                              (this.state.selectedConversation?.kind === 'business_to_business'
                                ? // B2B logic: Find the participant that isn't the logged-in account (matching conversation's account_id)
                                this.state.selectedConversation?.participants?.find(
                                  (p: any) => String(p.id) !== String(this.state.selectedConversation?.account_id)
                                )?.attributes?.business_name ||
                                // Fallback to the first participant if account_id matching isn't what you need
                                this.state.selectedConversation?.participants?.[0]?.attributes?.business_name
                                : // customer_chat logic: show customer first_name + last_name
                                this.getFullName(
                                  this.state.selectedConversation?.customer?.first_name,
                                  this.state.selectedConversation?.customer?.last_name
                                ))}
                          </Typography>
                  </Box>
                  <IconButton className={classes.postSettingsBtn} onClick={this.handleMenuOpen}>
                    <MoreVertIcon />
                  </IconButton>
                </Box>
                {/* Menu code remains same */}
              </div>

              {/* CHAT MESSAGES AREA */}
              <div
                ref={this.chatSectionRef}
                className={clsx(classes.chatMessagesArea, "chat-scroll-container")}
                style={
                  // Clear AppLayout's fixed mobile app bar plus this page's
                  // own contact-info header, both now pinned above it. Both
                  // heights are live-measured (not guessed) to avoid leaving
                  // dead space.
                  window.innerWidth < 950
                    ? { marginTop: this.state.mobileTopBarHeight + this.state.mobileContactHeaderHeight }
                    : undefined
                }
              >
                {this.state.isLoading ? (
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                    <CircularProgress />
                  </div>
                ) : (
                          <>
                            <div style={{ flexGrow: 1, minHeight: '10px' }} />
                            {this.state.chatSelectedContact.map((chat: any, index: number) => {
                              // 🟢 FIX: Replace this with your actual logged-in User/Account ID 
                              // (e.g., from localStorage, Redux, or global context). 
                              // Do not rely on `this.state.selectedConversation?.account_id` as it changes depending on who started the B2B conversation.
                              const currentAccountId = this.state.userDetails.id || localStorage.getItem("current_user_id");

                              // Determine if message is mine (safe string comparison for mix of string/number IDs)
                              const isMyMessage =
                                chat.sender_type === "AccountBlock::Account"
                                  ? String(chat.sender_id) === String(currentAccountId)
                                  : false;

                              const messageKey = `${chat?.id || "msg"}-${chat?.created_at || index
                                }-${index}`;

                              const showReactionTrigger =
                                this.state.hoveredMessageKey === messageKey;

                              const selectedReaction =
                                this.state.messageReactions[messageKey];

                              const isLastMessage =
                                index === this.state.chatSelectedContact.length - 1;

                              return (
                                <div
                                  key={messageKey}
                                  className={clsx(classes.chatDetailBox, {
                                    [classes.chatDetailBoxLast]: isLastMessage,
                                  })}
                                  onMouseEnter={() => this.handleMessageHover(messageKey)}
                                  onMouseLeave={this.handleMessageHoverEnd}
                                >
                                  {/* ================= RECEIVER ================= */}
                                  {!isMyMessage ? (
                                    <div className={classes.othersChat}>
                                      <div className={classes.singleConversation1}>
                                        {selectedReaction && (
                                          <div
                                            className={clsx(
                                              classes.reactionBadge,
                                              classes.reactionBadgeReceiver
                                            )}
                                          >
                                            {selectedReaction}
                                          </div>
                                        )}

                                        <div
                                          className={clsx(classes.singleConversation1Text, {
                                            [classes.emojiOnlyMessage]:
                                              this.isEmojiOnlyMessage(
                                                chat.content || chat.body || ""
                                              ),
                                          })}
                                          dangerouslySetInnerHTML={{
                                            __html: chat.content || chat.body || "",
                                          }}
                                        />

                                        {showReactionTrigger && (
                                          <IconButton
                                            size="small"
                                            className={classes.reactionTriggerBtnLeft}
                                            onClick={(event) =>
                                              this.openReactionPicker(
                                                event,
                                                messageKey,
                                                false
                                              )
                                            }
                                          >
                                            <KeyboardArrowDownIcon
                                              style={{ fontSize: 16 }}
                                            />
                                          </IconButton>
                                        )}
                                      </div>

                                      <div className={classes.delieveredTime}>
                                        {moment(chat.created_at).format("hh:mm A")}
                                      </div>
                                    </div>
                                  ) : (
                                    /* ================= SENDER ================= */
                                    <div className={classes.myChat}>
                                      <div className={classes.singleConversation1myChat}>
                                        {selectedReaction && (
                                          <div
                                            className={clsx(
                                              classes.reactionBadge,
                                              classes.reactionBadgeSender
                                            )}
                                          >
                                            {selectedReaction}
                                          </div>
                                        )}

                                        {showReactionTrigger && (
                                          <IconButton
                                            size="small"
                                            className={classes.reactionTriggerBtn}
                                            onClick={(event) =>
                                              this.openReactionPicker(
                                                event,
                                                messageKey,
                                                true
                                              )
                                            }
                                          >
                                            <KeyboardArrowDownIcon
                                              style={{ fontSize: 16 }}
                                            />
                                          </IconButton>
                                        )}

                                        <div
                                          className={clsx(
                                            classes.singleConversation1TextmyChat,
                                            {
                                              [classes.emojiOnlyMessage]:
                                                this.isEmojiOnlyMessage(
                                                  chat.content || chat.body || ""
                                                ),
                                            }
                                          )}
                                          style={{
                                            // iMessage (iPhone-to-iPhone) shows blue; SMS fallback shows green,
                                            // matching Apple Messages' own color convention.
                                            backgroundColor: chat.device === "sms" ? "#25D366" : "#007AFF",
                                          }}
                                          dangerouslySetInnerHTML={{
                                            __html: chat.content || chat.body || "",
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                          alignItems: "center",
                                          marginTop: 4,
                                        }}
                                      >
                                        <div className={classes.delieveredTime}>
                                          {moment(chat.created_at).format("hh:mm A")}
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                            <div className="messages-anchor" ref={this.messagesEndRef} style={{ height: "1px" }} />
                            <Popover
                              open={Boolean(this.state.reactionPickerPosition)}
                              anchorReference="anchorPosition"
                              anchorPosition={this.state.reactionPickerPosition || undefined}
                              onClose={this.closeReactionPicker}
                              transformOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              PaperProps={{
                                style: {
                                  marginTop: -4,
                                  borderRadius: 999,
                                  overflow: "hidden",
                                },
                              }}
                            >
                              <Box className={classes.reactionPickerContainer}>
                                {["👍", "❤️", "😂", "😮", "😢", "🙏"].map((emoji) => (
                                  <IconButton
                                    key={emoji}
                                    className={classes.reactionOptionBtn}
                                    onClick={() => this.addMessageReaction(emoji)}
                                  >
                                    {emoji}
                                  </IconButton>
                                ))}
                                {/* <div className={classes.reactionPlus}>+</div> */}
                              </Box>
                            </Popover>
                          </>
                )}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
        {this.state.openInfoModal ?
        <div
          className={classes.bottomRight}
          style={
            this.state.mobileKeyboardOffset > 0
              ? { bottom: this.state.mobileKeyboardOffset }
              : undefined
          }
        >
          <hr className={classes.messageDivider2} />
          <div className={classes.sendMessage}>
            <div className={classes.meUserIcon}>
              {this.getProfilePic(this.state.chatSelectedContact.attributes?.profile_pic_url, classes, true)}
            </div>
            <img src={backArrow} 
              className={classes.showMoreFeature} 
              alt="" 
              onClick={() => this.setState({isDocCameraAutoVisible: !this.state.isDocCameraAutoVisible})}
              style={this.state.isDocCameraAutoVisible ? {transform: "rotate(270deg)"} : {transform: "rotate(180deg)"}}
              />

              <Box className={classes.messageInputContainer}>
                
                <Box className={classes.messageInputField}>
                  <TextField
                    data-test-id="newMessageFiled"
                    placeholder="Type your message"
                    variant="outlined"
                    value={this.state.newMessage}
                    fullWidth
                    multiline
                    minRows={1}
                    maxRows={4}
                    name="comment"
                    className={classes.messageField}
                    onChange={(e) => this.setState({ newMessage: e.target.value })}
                    InputProps={{
                      style: {
                        resize: 'none',
                        overflow: 'hidden',
                        lineHeight: '1.5',
                        fontSize: '15px',
                        fontFamily: 'Segoe UI, Helvetica Neue, Helvetica, Lucida Grande, Arial, Ubuntu, Cantarell, Fira Sans, sans-serif',
                        border:'1px solid #000000'
                      },
                    }}
                    inputProps={{
                      style: {
                        // padding: '9px 12px',
                        overflowY: 'auto',
                      },
                    }}
                  />
                </Box>
                
                {/* Action Icons - Desktop Only (shown inline) */}
                {(typeof window === 'undefined' || window.innerWidth >= 950) && (
                <Box className={classes.actionIconsContainer}>
                  <IconButton 
                    className={classes.actionButton} 
                    title="Attach Document"
                    onClick={() => this.handleDocumentUpload()}
                  >
                    <img src={document} alt="Document" className={classes.actionIconImage} />
                  </IconButton>
                  <IconButton 
                    className={classes.actionButton} 
                    title="Attach Photo/Video"
                    onClick={() => this.handleCameraUpload()}
                  >
                    <img src={camera} alt="Camera" className={classes.actionIconImage} />
                  </IconButton>
                  <Box className={classes.variablesContainer}>
                    <SimpleMessageVariablesDropdown
                      onVariableSelect={(variable: string) => {
                        // Just insert the variable string (e.g., :business_name:) into the message
                        // The variable will be processed when the message is sent
                        const currentMessage = this.state.newMessage;
                        const newMessage = currentMessage + variable;
                        this.setState({ newMessage });
                      }}
                      placeholder=":a:"
                      disabled={false}
                    />
                  </Box>
                </Box>
                )}
                
                {/* Send Button */}
                <Button
                  data-test-id="sendNewMsgBtn"
                  className={classes.sendButtonNew}
                  onClick={() => this.sendNewMessage()}
                  disabled={!this.state.newMessage.trim()}
                >
                  Send
                </Button>
              </Box>
            {/* <Box className={classes.docCameraAutoContainerDesktop}>
              {renderCameraDocAuto()}
            </Box> */}
          </div>
          
          {/* Mobile Action Icons - At Bottom (controlled by arrow button) */}
          {this.state.isRightSideVisibleForMobileView && this.state.isDocCameraAutoVisible && (
            <Box className={classes.mobileAttachmentIcons}>
              <IconButton 
                className={classes.mobileActionButton} 
                onClick={() => this.handleDocumentUpload()}
              >
                <img src={document} alt="Document" className={classes.mobileActionIcon} />
              </IconButton>
              <IconButton 
                className={classes.mobileActionButton} 
                onClick={() => this.handleCameraUpload()}
              >
                <img src={camera} alt="Camera" className={classes.mobileActionIcon} />
              </IconButton>
              <Box className={classes.mobileVariablesContainer}>
                <SimpleMessageVariablesDropdown
                  onVariableSelect={(variable: string) => {
                    // Just insert the variable string (e.g., :business_name:) into the message
                    // The variable will be processed when the message is sent
                    const currentMessage = this.state.newMessage;
                    const newMessage = currentMessage + variable;
                    this.setState({ newMessage });
                  }}
                  placeholder=":a:"
                  disabled={false}
                />
              </Box>
            </Box>
          )}
          {/* <Box className={classes.docCameraAutoContainerMobile} style={this.state.isDocCameraAutoVisible ? {display: "flex"}: {display: "none"}}>
            {renderCameraDocAuto()}
          </Box> */}
        </div>
        : "" }
      </Card>
    </Box>
    }

    const renderForMobileView = () => {
      return <Box className={classes.messageContainerMobile}>
        {this.state.isLeftSideVisibleForMobileview && renderLeftSide()}
        {this.state.isCenterSideVisibleForMobileView && renderCenterSide()}
        {this.state.isRightSideVisibleForMobileView && renderRightSide()}
        {this.state.addNewMessageMobile && renderAddNewMessageModal()}
        {this.state.createNewContactMobile && renderAddContact()}
      </Box>
    }

    return (
      <>
        <Snackbar
          open={this.state.showAlert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            severity={this.state.errorAlertMessage ? "error" : "success"}
          >
            {this.state.showSuccess}
          </MuiAlert>
        </Snackbar>
        <Modal 
          open={this.state.editFolderModal}
          onClose={this.closeEditFolderModal}
          aria-labelledby="edit-folder-modal-title"
          aria-describedby="edit-folder-modal-description"
          data-test-id="editFolderModal"
        >
          <div className={classes.editModal}>
            <Typography className={classes.modalHeading}>
              Edit Folder Name
            </Typography>
            <TextField
              fullWidth
              variant="outlined"
              value={this.state.editFolderName}
              onChange={this.handleEditFolderNameChange}
              placeholder="Enter folder name"
              data-test-id="editFolderNameInput"
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  this.handleSaveFolderName();
                }
              }}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            />
            <Box style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <Button
                data-test-id="cancelEditFolder"
                onClick={this.closeEditFolderModal}
                style={{
                  textTransform: "none",
                  color: "#000",
                }}
              >
                Cancel
              </Button>
              <Button
                data-test-id="saveEditFolder"
                onClick={this.handleSaveFolderName}
                variant="contained"
                style={{
                  backgroundColor: "#000",
                  color: "#FFF",
                  textTransform: "none",
                }}
                disabled={!this.state.editFolderName.trim()}
              >
                Save
              </Button>
            </Box>
          </div>
        </Modal>
        <Modal open={this.state.teammatesModal}
          onClose={this.closeModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          data-test-id="webUpdateModal"
        >
          <div className={classes.teammadeModalBox}>
            <div>
              <div className={classes.flexSB}>
                <Typography className={classes.modalHeading}>
                  Teammates
                </Typography>
                <IconButton
                  onClick={this.closeModal}
                  className={classes.crossIconTbn}
                >
                  <img src={closeIcon} alt="" />
                </IconButton>
              </div>
              <hr className={classes.messageDivider} />
              <input
                placeholder=" Search 1"
                style={{ fontFamily: "Inter" }}
                className={classes.searchFieldTeammate}
              />
              <div className={classes.teammateBox}>
                {this.state.teammates.map((teammate: any) => {
                  return (
                    <div
                      data-test-id="teammateBtn"
                      className={classes.singleTemmate}
                      key={teammate.id}
                      onClick={() => {
                        this.assignFolderToTeamate(teammate);
                      }}
                    >
                      <div className={classes.teamMateImage}>
                        {this.getProfilePic(teammate.attributes?.profile_photo, classes)}
                      </div>
                      <div className={classes.text}>
                        {this.getFirstName(teammate.attributes?.name)}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className={classes.modalBtn}>
              <button className={classes.cancelBtn}> Cancel</button>
              <span style={{ marginLeft: "20px" }}>
                <button className={classes.acceptBtn}> Accept</button>
              </span>
            </div>
          </div>
        </Modal>
        <div className={classes.messageContainter}
          data-test-id="messageContainter"
        >
          {renderLeftSide()}
          {renderCenterSide()}
          {renderRightSide()}
        </div>
        {renderForMobileView()}
        <Popover open={automationOpen}
          id="simple-popover"
          anchorEl={this.state.automationModal}
          onClose={this.handleAutomationPopOver}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          classes={{
            paper: classes.popOverPaper,
          }}
        >
          <Box className={classes.automationModal} data-test-id="automationBox">
            <Box className={classes.automationSearchBox}>
              <input
                data-test-id="automationSearchInput"
                placeholder="Search 2"
                name="automationSearchI"
                style={{ fontFamily: "Inter" }}
                className={classes.searchFieldAutomation}
                value={this.state.automationSearchQuery}
                onChange={(e: any) => this.handleAutomationSearch(e)}
              />
            </Box>

            <Box className={classes.automationBottomBox}>
              {this.state.autoamtionFilterData.length ? (
                this.state.autoamtionFilterData.map((item: any) => (
                  <Box
                    data-test-id="automationClick"
                    onClick={() => this.handleAutomationItemClick(item)}
                    key={item.name}
                    className={classes.automationListBox}
                  >
                    <Typography className={classes.automationLtext}>
                      {item.name}
                    </Typography>
                    <Typography className={classes.automationRtext}>
                      {item.type}
                    </Typography>
                  </Box>
                ))
              ) : (
                <Typography align="center" className={classes.automationLtext}>
                  No Message Found!
                </Typography>
              )}
            </Box>
          </Box>
        </Popover>
        <Modal open={this.state.newContactModal}
          onClose={this.closeNewContactModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          data-test-id="newContactModal"
          className={classes.addContactModalStyle}
        >
          {renderAddContact()}
        </Modal>
        <Menu
          id="chat-actions-menu"
          anchorEl={this.state.callMenuModal}
          keepMounted
          open={Boolean(this.state.callMenuModal)}
          onClose={this.handleMenuClose}
          classes={{
            paper: classes.menuPaper,
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem
            data-test-id="chatActionCreateContact"
            className={classes.chatActionMenuItem}
            onClick={() => {
              this.handleMenuClose();
              this.openNewContactModal();
            }}
          >
            <CreateIcon className={classes.chatActionMenuIcon} />
            <Typography className={classes.chatActionMenuText}>Create Contact</Typography>
          </MenuItem>
          <MenuItem
            data-test-id="chatActionArchive"
            className={classes.chatActionMenuItem}
            onClick={this.handleMenuClose}
          >
            <ArchiveOutlinedIcon className={classes.chatActionMenuIcon} />
            <Typography className={classes.chatActionMenuText}>Archive Chat</Typography>
          </MenuItem>
        </Menu>
      </>
    );
  }
}

export const commonStyles: any = {
  text: {
    fontSize: "16px",
    fontFamily: "Inter",
    fontWeight: 600,
  },
};

const styles = (theme: Theme) =>
  createStyles({
    addContactModalStyle:{
      [theme.breakpoints.down(950)]: {
        display: "none",
      },
    },
    scrollFolderBox: {
      height: "200px",
      overflowY: "auto",
      [theme.breakpoints.down(950)]: {
        height: "unset"
      },
    },
    itagBtn: {
      position: "absolute",
      top: "6px",
      bottom: "0",
      right: "8px",
      [theme.breakpoints.down(950)]: {
        position: "unset",
        marginRight: "12px"
      },
    },
    searchContainer: {
      position: "relative",
      width: "100%",
    },
    
    searchSuggestion: {
      position: "absolute",
      top: "48px",
      left: 0,
      right: 0,
      background: "#fff",
      border: "1px solid #E5E7EB",
      borderRadius: "10px",
      boxShadow: "0px 8px 24px rgba(0,0,0,0.12)",
      maxHeight: "320px",
      overflowY: "auto",
      zIndex: 9999,
    },
    
    searchSuggestionItem: {
      display: "flex",
      alignItems: "center",
      padding: "12px 16px",
      cursor: "pointer",
    
      "&:hover": {
        background: "#F8F8F8",
      },
    },
    
    userAvatar: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      objectFit: "cover",
    },
    
    avatarPlaceholder: {
      width: 44,
      height: 44,
      borderRadius: "50%",
      background: "#2563EB",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      fontSize: 18,
    },
    
    userInfo: {
      marginLeft: 12,
    },
    
    userName: {
      fontSize: 15,
      fontWeight: 600,
      color: "#222",
    },
    
    userSubTitle: {
      fontSize: 13,
      color: "#777",
      marginTop: 2,
    },
    crossIconTbn: {
      position: "absolute",
      top: "15px",
      right: "25px",
    },
    addBtn: {
      width: "100%",
      backgroundColor: "#FFC629",
      color: "#000",
      fontSize: "16px",
      fontWeight: 600,
      padding: "10px 0",
      margin: "10px 0",
      "&:hover": {
        backgroundColor: "#FFC629",
        color: "#000",
      },
    },
    backBtn: {
      width: "100%",
      backgroundColor: "#000",
      color: "#ffffff",
      fontSize: "16px",
      fontWeight: 600,
      padding: "10px 0",
      margin: "10px 0",
      "&:hover": {
        backgroundColor: "#000",
        color: "#ffffff",
      },
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    inputLable: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#334155",
      paddingTop: "5px",
    },
    addnewconH: {
      fontSize: "24px",
      fontWeight: 600,
      lineHeight: "32px",
    },
    errorMsg: {
      color: "red",
      fontSize: "12px",
      paddingLeft: "2px",
    },
    addNewContectInput: {
      width: "100%",
      margin: "5px 0",
      [theme.breakpoints.down(950)]: {
        "& .MuiOutlinedInput-root":{
          borderRadius: "8px"
        }
      },
    },
    newContectModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "40px",
      width: "30%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "0px 0px 24px 0",
      minWidth: "380px",
      [theme.breakpoints.down(950)]: {
        width: "100%",
        top: "0",
        left: "0",
        transform: "none",
        padding: "56px 24px",
        borderRadius: "0",
        overflowY: "scroll",
        minWidth: "340px",
        height: "100vh",
        paddingBottom: "120px"
      },
    },
    automationListBox: {
      padding: "5px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      "&:hover": {
        backgroundColor: "rgba(217, 217, 217, 0.2)",
        cursor: "pointer",
      },
    },
    automationLtext: {
      color: "#64748B",
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "36px",
    },
    automationRtext: {
      color: "#64748B",
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: "36px",
    },
    automationBottomBox: {
      padding: "20px",
    },
    automationModal: {
      width: "450px",
      padding: "10px",
      borderRadius: "12px 12px 0px 12px",
    },
    cancelBtn: {
      background: "#000000",
      height: "44px",
      width: "87px",
      color: "white",
      borderRadius: "8px",
      borderStyle: "none",
      fontFamily: "Inter",
      fontWeight: 700
    },
    acceptBtn: {
      background: "#FFC629",
      height: "44px",
      width: "87px",
      borderRadius: "8px",
      borderStyle: "none",
      fontFamily: "Inter",
      fontWeight: 700
    },
    modalBtn: {
      textAlign: "right",
      marginTop: "20px",
    },
    text: {
      ...commonStyles.text,
    },
    singleTemmate: {
      cursor: "pointer",
      width: "20%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingTop: "15px",
    },
    infoText1: {
      fontSize: "16px",
      fontFamily: "Inter",
      fontWeight: "bold",
      paddingTop: "15px",
      cursor: "pointer",
    },
    fromText:{
      fontSize: "16px",
      fontFamily: "Inter",
      fontWeight: "bold",
      paddingTop: "15px",
      cursor: "pointer",
      display: 'ruby',
      [theme.breakpoints.down(950)]: {
        fontSize: '24px',
        display: 'block'
      },
    },
    breakOnMobile:{
      [theme.breakpoints.up(950)]: {
        display:'none'
      },
    },
    businessNameText:{
      [theme.breakpoints.down(950)]: {
        fontSize: "20px",
        margin: "24px 0 0"
      },
    },
    modalHeading: {
      fontSize: "24px",
      fontFamily: "Inter",
      fontWeight: 700,
    },
    infoText2: {
      ...commonStyles.text,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      marginTop: "20px",
      gap: "5px",
      padding: "5px 5px 5px 15px",
      position: "relative", // Ensure positioning for pseudo-element
      "& > div": {
        flex: 1
      },
      "&:hover": {
        color: "#FFF",
        backgroundColor: "#000",
        "& svg": {
          color: "#fff !important",
        },
        "& img": {
          filter: "brightness(100)"
        }
      },
      [theme.breakpoints.down(950)]: {
        height: "50px",
        marginTop: "0px",
        "&::after": {
        content: '""',
        display: "block",
        width: "100%",
        height: "1px",
        backgroundColor: "#8F6C0E",
        position: "absolute",
        bottom: "-1px",
        left: 0
      },
      },
    },
    
    infoTextFolder: {
      ...commonStyles.text,
      display: "flex",
      justifyContent: "space-around",
      alignItems: "center",
      cursor: "pointer",
      gap: "5px",
      padding: "5px 5px 5px 15px",
      position: "relative",
      "& > div": {
        flex: 1
      },
      [theme.breakpoints.down(950)]: {
        "&::after": {
          content: '""',
          display: "block",
          width: "100%",
          height: "1px",
          backgroundColor: "#8F6C0E",
          position: "absolute",
          bottom: "0px",
          left: 0
        }
      },
    },
    
    infoText3: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 700,
      cursor: "pointer",
      [theme.breakpoints.down(950)]: {
        justifyContent: "space-between",
        width: "100%"
      },
    },
    messageContainter: {
      position: "relative",
      display: "flex",
      height: "91vh",
      [theme.breakpoints.down(1150)]: {
        height: "82vh"
      },
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    messageContainerMobile: {
      [theme.breakpoints.up(950)]: {
        display: "none"
      },
    },
    leftBox: {
      overflow: "auto",
      flex: "0.15",
      backgroundColor: "#FFC629",
      paddingTop: "20px",
      paddingLeft: "10px",
      paddingRight: "10px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      [theme.breakpoints.down(1150)]: {
        flex: "0.20"
      },
      [theme.breakpoints.down(650)]: {
        padding: "0px",
        height: "calc(100vh - 121px)"
      },
    },
    addNewIconButton:{
      [theme.breakpoints.down(950)]: {
        display: 'none'
      },
    },
    addNewChatMobileButton: {
      position: "fixed",
      right: "8px",
      bottom: "66px",
      width: "58px",
      height: "58px",
      backgroundColor: "#FFC629",
      borderRadius: "100%",
      display: 'flex',
      alignItems: "center",
      justifyContent: 'center',
      "& img":{
        width: "38px",
        heigth: "38px"
      },
      [theme.breakpoints.up(950)]: {
        display: 'none'
      },
      [theme.breakpoints.down(950)]: {
        bottom: "calc(66px + env(safe-area-inset-bottom))",
      },
    },
    centerBox: {
      height: "100%",
      flex: "0.25",
      [theme.breakpoints.down(1150)]: {
        flex: "0.35"
      },
      [theme.breakpoints.down(950)]: {
        height: "96%"
      },
    },
    rightBox: {
      marginLeft: "15px",
      marginTop: "15px",
      flex: "0.59",
      minHeight: 0, 
      [theme.breakpoints.down(1150)]: {
        flex: "0.45"
      },
      [theme.breakpoints.down(950)]: {
        marginLeft: "0",
        marginTop: "0",
        width: "100%",
        maxWidth: "100vw",
        boxSizing: "border-box",
        overflowX: "hidden",
      },
    },
    folderContainer: {
      paddingTop: "40px",
      // height: "250px",
      // overflowY: "scroll",
    },
    folerAndFolderCreateButtonContainer:{
      [theme.breakpoints.down(950)]: {
        display: "flex",
        flexDirection: "column-reverse",
      },
    },
    createFolderBtn: {
      ...commonStyles.text,
      textTransform: "none",
      backgroundColor: "black",
      color: "white",
      borderRadius: "11px",
      marginRight: "20px",
      width: "80%",
      "&:hover": {
        width: "80%",
        "&:hover": {
          backgroundColor: "black",
          color: "white",
        },
      },
    },
    btnContainer: {
      textAlign: "center",
      paddingTop: "15px",
      [theme.breakpoints.down(950)]: {
        marginBottom: "12px"
      },
    },
    settingsIcon: {
      color: "rgba(0, 0, 0, 0.70)",
      width: "24px",
      height: "24px",
      transform: "rotate(180deg)",
    },
    textCapitalize: {
      textTransform: "capitalize",
    },
    buttonSettings: {
      fontSize: 12,
    },
    bottomleft: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    everyBrandLogo: {
      marginTop: "15px",
    },
    imageIcons: {
      paddingRight: "10px",
    },
    messageCard: {
      marginLeft: "15px",
      marginTop: "15px",
      padding: "30px",
      overflow: "auto",
      boxShadow: "none",
      height: "96%",
      [theme.breakpoints.down(650)]: {
        margin: "12px",
        height: "auto",
      },
    },
    messageCardRight: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      padding: "30px",
      paddingBotton: "18px",
      overflow: "hidden",
      boxShadow: "none",
      minHeight: 0,
      width: "100%",
      boxSizing: "border-box",
      // `overflow: hidden` above clips `position: fixed` descendants to this
      // box's own bounds instead of letting them render against the real
      // viewport — that was hiding the fixed mobile header. Keep horizontal
      // clipping (still needed to stop content spilling sideways) but let
      // vertical content render outside this box on mobile.
      [theme.breakpoints.down(950)]: {
        overflowY: "visible",
      },
      [theme.breakpoints.down(650)]: {
        padding: "12px",
        margin: "0px",
        marginTop: "12px",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
      },
    },
    chatSection:{
      height: "calc(100vh - 152px)",
      display: "flex",
      flexDirection: "column",
      // overflowY: "auto",
      minHeight: 0,
      scrollBehavior: "smooth",
      // Padding must be included in `height`, not added on top of it — otherwise
      // this box renders taller than the viewport and the bottom of its content
      // (the messages area / last message) gets pushed past the visible screen.
      boxSizing: "border-box",
      [theme.breakpoints.down(1150)]: {
        height: "calc(100vh - 218px)",
        paddingBottom: "140px",
      },
      [theme.breakpoints.down(950)]: {
        height: "calc(100vh - 20px)",
        paddingBottom: "140px",
      },
    },
    chatMessagesArea: {
      height: "calc(100vh - 200px)",
      overflowY: "scroll",
      display: "flex",
      flexDirection: "column",
      padding: "10px",
      marginTop: "30px",
      overscrollBehaviorY: "contain",
      marginBottom: "50px",
      boxSizing: "border-box",
      // On mobile, bottomRight becomes `position: fixed`, floating above the
      // viewport independent of this box's flow — reserve extra clearance via
      // padding (not margin) so it participates in scrollHeight, guaranteeing
      // the last message can scroll fully above the fixed send bar.
      [theme.breakpoints.down(950)]: {
        height: "calc(100vh - 158px)",
        marginBottom: 0,
        paddingBottom: "30px",
      },
    },
    bottomRight: {
      position: "absolute",
      bottom: "16px",
      width: "95%",
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      zIndex: 10,
      flexShrink: 0,
      [theme.breakpoints.down(950)]: {
        height: "auto",
        width: "100%",
        paddingRight: "16px",
        boxSizing: "border-box",
        maxWidth: "100vw",
        overflowX: "hidden",
        position: "fixed",
        // This bar only ever renders while a conversation is open, and the
        // shared bottom tab bar is always hidden in that exact state — so
        // there's no tab bar left to clear space for; sit flush above the
        // keyboard/safe area instead of leaving a dead gap underneath.
        bottom: "env(safe-area-inset-bottom)",
      },

    },
    searchField: {
      width: "85%",
      backgroundColor: "#D9D9D933",
      height: "44px",
      borderRadius: "98px",
      borderStyle: "none",
      paddingLeft: "40px",
      backgroundImage: `url(${search_icon})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "10px center",
      backgroundSize: "20px",
      [theme.breakpoints.down(650)]: {
        width: "100%",
        backgroundColor: "#ebebebb3",
      },
    },
    searchFieldTeammate: {
      fontFamily: "Inter",
      width: "100%",
      backgroundColor: "#F7F8FC",
      height: "40px",
      borderRadius: "98px",
      borderStyle: "none",
      paddingLeft: "40px",
      marginTop: "20px",
      backgroundImage: `url(${search_icon})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "10px center",
      backgroundSize: "20px",
      "&::placeholder": {
        fontFamily: "Inter",
      },
    },
    automationSearchBox: {
      display: "flex",
      flexDirection: "row",
    },
    searchFieldAutomation: {
      fontFamily: "Inter",
      width: "100%",
      backgroundColor: "rgba(217, 217, 217, 0.2)",
      height: "40px",
      borderRadius: "98px",
      borderStyle: "none",
      paddingLeft: "40px",
      backgroundImage: `url(${search_icon})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "10px center",
      backgroundSize: "20px",
      "&::placeholder": {
        fontFamily: "Inter",
      },
    },
    messageInputContainer: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      width: "100%",
      backgroundColor: "#fff",
      minWidth: 0, // Allow flex item to shrink
      boxSizing: "border-box",
      maxWidth: "100%",
      [theme.breakpoints.down(480)]: {
        gap: "8px",
      },
      [theme.breakpoints.down(360)]: {
        gap: "4px",
      },
    },
    messageInputField: {
      flex: 1,
      minWidth: 0, // Allow to shrink properly
      display: "flex",
      alignItems: "center",
    },
    actionIconsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flexShrink: 0, // Prevent icons from shrinking
      alignSelf: "flex-end",
      [theme.breakpoints.down(480)]: {
        gap: "6px",
      },
      [theme.breakpoints.down(360)]: {
        gap: "4px",
      },
    },
    actionButton: {
      width: "32px",
      height: "32px",
      padding: "6px",
      borderRadius: "50%",
      backgroundColor: "transparent",
      flexShrink: 0,
      "&:hover": {
        backgroundColor: "#f0f0f0",
      },
      [theme.breakpoints.down(360)]: {
        width: "28px",
        height: "28px",
        padding: "4px",
      },
    },
    actionIconImage: {
      width: "20px",
      height: "20px",
      [theme.breakpoints.down(360)]: {
        width: "18px",
        height: "18px",
      },
    },
    variablesContainer: {
      position: "relative",
      zIndex: 1000,
      "& .MuiButton-root": {
        minWidth: "32px",
        height: "32px",
        padding: "6px",
        borderRadius: "50%",
        backgroundColor: "transparent",
        fontSize: "14px",
        fontWeight: 600,
        color: "#333",
        "&:hover": {
          backgroundColor: "#f0f0f0",
        },
      },
      "& .MuiMenu-paper": {
        maxWidth: "300px",
        maxHeight: "400px",
        overflow: "auto",
        "& .MuiMenu-list": {
          padding: "8px 0",
        },
      },
    },
    sendButtonNew: {
      backgroundColor: "#FFD700",
      color: "#000",
      fontWeight: 600,
      borderRadius: "20px",
      padding: "8px 16px",
      textTransform: "none",
      fontSize: "14px",
      minWidth: "70px",
      height: "36px",
      alignSelf: "flex-end",
      flexShrink: 0,
      "&:hover": {
        backgroundColor: "#FFC700",
      },
      "&:disabled": {
        backgroundColor: "#e0e0e0",
        color: "#9e9e9e",
      },
    },
    messageField: {
      "& .MuiOutlinedInput-root": {
        backgroundColor: "#ffffff",
        borderRadius: "21px",
        border: "none",
        boxShadow: "none",
        transition: "all 0.2s ease",
        padding: "0",
        minHeight: "42px", // Minimum height for 1 line
        "&:hover": {
          backgroundColor: "#ffffff",
          boxShadow: "none",
        },
        "&.Mui-focused": {
          backgroundColor: "#ffffff",
          boxShadow: "none",
          border: "none",
        },
        "& fieldset": {
          border: "none",
        },
        "&:hover fieldset": {
          border: "none",
        },
        "&.Mui-focused fieldset": {
          border: "none",
        },
      },
      "& .MuiOutlinedInput-multiline": {
        padding: "0",
        minHeight: "42px", // Minimum height for 1 line
        maxHeight: "108px", // Maximum height for 4 lines (4 * 22.5px + 18px padding)
        overflow: "hidden",
      },
      "& .MuiInputBase-inputMultiline": {
        padding: "6px 12px !important",
        margin: "0 !important",
        lineHeight: "1.5",
        fontSize: "15px",
        fontFamily: "Segoe UI, Helvetica Neue, Helvetica, Lucida Grande, Arial, Ubuntu, Cantarell, Fira Sans, sans-serif",
        color: "#111b21",
        maxHeight: "90px", // Max height for scrolling (4 lines * 22.5px)
        overflowY: "auto !important",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(0, 0, 0, 0.2)",
          borderRadius: "3px",
          "&:hover": {
            background: "rgba(0, 0, 0, 0.3)",
          },
        },
        "&::placeholder": {
          color: "#667781",
          opacity: 1,
          fontSize: "15px",
        },
      },
      [theme.breakpoints.down(950)]: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
          minHeight: "42px",
        },
        "& .MuiOutlinedInput-multiline": {
          minHeight: "42px",
          maxHeight: "108px",
        },
        "& .MuiInputBase-inputMultiline": {
          maxHeight: "90px",
        },
      },
    },
    headingText: {
      fontSize: "24px",
      fontFamily: "Inter",
      fontWeight: 700,
      paddingTop: "20px",
    },
    filterBox: {
      paddingTop: "20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    filterText: {
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 500,
      color: "#64748B",
    },
    filterInputModalBase:{
      maxWidth: "180px",
      width: "100%",
      cursor: "pointer",
      "& .MuiOutlinedInput-root":{
        borderRadius: "8px"
      },
      "& .MuiSelect-outlined.MuiSelect-outlined":{
        padding: "4px 32px 4px 8px"
      },
      "& .PrivateNotchedOutline-root-187":{
        top: "-10px"
      }
    },
    filterMenuItem:{
      "&.MuiMenu-paper":{
        borderRadius: "12px",
        width: "180px"
      },
      "&:hover": {
      backgroundColor: "#000",
      color: "#FFF",
      },
      "&.Mui-selected": {
        backgroundColor: "#000 !important",
        color: "#FFF !important",
      },
    },
    addNewMessageContainer:{
      [theme.breakpoints.down(950)]: {
        margin: "48px 24px"
      },
    },
    crossIcon:{
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    flexSB: {
      display: "flex",
      justifyContent: "space-between",
    },
    messageScreenUserOneTime:{
      padding: "12px"
    },
    messageDivider: {
      marginTop: "20px",
      height: "1px",
      border: "none",
      backgroundColor: "#DADADA",
    },
    dateDivider: {
      height: "1px",
      border: "none",
      backgroundColor: "#DADADA",
      marginLeft: "50px",
      width: "60%",
    },
    messageDivider2: {
      // marginTop: "30vh",
      height: "1px",
      border: "none",
      backgroundColor: "#DADADA",
    },
    inputFieldMessages: {
      paddingTop: "20px",
      '& .MuiOutlinedInput-root': {
        borderRadius: '4px',
      },
      [theme.breakpoints.down(950)]: {
        "& .MuiInputBase-root":{
          border: '1px solid #CBD5E1',
          borderRadius: "8px",
          padding: "12px",
          backgroundColor: "#fff"
        },
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: '2px solid #ccc',
        },
        '& .MuiInput-underline::after':{
          border: "none"
        },
        '& .MuiInput-underline::before':{
          border: "none"
        }
      },
    },
    phoneFieldMessage:{
      [theme.breakpoints.down(650)]: {
        display: "none"
      },
      
    },
    countryPhoneNumber:{
      paddingTop: "20px",
      [theme.breakpoints.up(650)]: {
        display: "none"
      },
    },
    input: {
      "&::placeholder": {
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: 700,
        color: "#CBD5E1",
        [theme.breakpoints.down(950)]: {
          fontSize: "16px",
          fontWeight: 400,
          color: "#64748B"
        },
      },
    },
    inputName: {
      fontSize: "20px",
      fontWeight: 700,
      "&::placeholder": {
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: 700,
        color: "#CBD5E1",
        [theme.breakpoints.down(950)]: {
          fontSize: "16px",
          fontWeight: 400,
          color: "#64748B"
        },
      },
    },
    newContact: {
      marginTop: "30px",
      backgroundColor: "#FFC629",
      height: "46px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "20px",
      [theme.breakpoints.down(950)]: {
        borderRadius: '8px',
        width: "285px",
        marginLeft: "auto",
        marginRight: "auto",
        height: "56px",
      },
    },
    rightSection: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-end",
      gap: "6px"
    },
    
    deviceLabel: {
      fontSize: "12px",
      fontWeight: 500,
      padding: "2px 8px",
      borderRadius: "12px",
      textTransform: "uppercase",
    },
    
    imsg: {
      backgroundColor: "#007AFF", // iMessage blue
      color: "#fff"
    },
    
    sms: {
      backgroundColor: "#34C759", // SMS green
      color: "#fff"
    },
    sendMessage: {
      paddingTop: "4px",
      display: "flex",
      alignItems: "flex-end",
      width: "100%",
      boxSizing: "border-box",
      maxWidth: "100%",
      gap: "8px",
      [theme.breakpoints.down(950)]: {
        backgroundColor: "#fff",
        paddingBottom: "18px",
        paddingLeft: "6px",
        paddingRight: "6px",
        alignItems: "flex-end",
        gap: "8px",
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
      },
    },
    meUserIcon:{
      height: "32px",
      width: "32px",
      border: "1px solid #E2E8F0",
      borderRadius: "100%",
      alignSelf: "flex-end",
      flexShrink: 0,
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    showMoreFeature: {
      height: "24px",
      width: "24px",
      transform: "rotate(180deg)",
      [theme.breakpoints.up(950)]: {
        display: "none"
      },
    },
    addContactButton: {
      backgroundColor: "#FFC629",
      color: "#0F172A",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "56px",
      width: "360px",
      borderRadius: "8px",
      fontFamily: "Inter",
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "24px",
      textTransform: "none",
      margin: "24px auto",
      marginBottom: '120px',
      [theme.breakpoints.down(650)]: {
        width: "285px"
      },
      "&:hover": {
        backgroundColor: "#FFC629",
      },
      [theme.breakpoints.up(950)]: {
        display: 'none'
      },
    },
    allConsversatitonBox: {
      marginTop: "20px",
      [theme.breakpoints.down(950)]: {
        paddingBottom: "calc(64px + env(safe-area-inset-bottom))",
      },
    },
    conversationContainer: {
      display: "flex",
      marginTop: "10px",
    },
    conversationImage1: {
      backgroundColor: "#FFC629",
      borderRadius: "50%",
      // padding: "0 7px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      height: "32px",
      width: "32px",
    },

    conversationImage: {
      backgroundColor: "#FFC629",
      borderRadius: "50%",
      padding: "0 7px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      height: "44px",
      width: "44px",
    },
    teamMateImage: {
      backgroundColor: "#FFC629",
      borderRadius: "50%",
      padding: "0 7px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      height: "117px",
      width: "113px",
    },
    conversationDetails: {
      marginLeft: "10px",
    },
    nameText: {
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 700,
    },
    msgTxt: { fontSize: "14px", fontFamily: "Inter", fontWeight: 400 },
    dateText: {
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 400,
      color: "#64748B",
    },
    singleConversation: {
      width: "100%",
      padding: "5px",
      marginTop: "5px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(217,217,217,0.2)",
        borderRadius: "6px",
      },
    },
    docCameraAutoContainer:{
      display: "flex",
      alignItems: 'center'
    },
    docCameraAutoContainerDesktop:{
      [theme.breakpoints.down(950)]: {
        display: "none"
      },
    },
    sendMessageIcon:{
      heigth: "28px",
      width: "28px",
      [theme.breakpoints.up(950)]: {
        display: "none",
      },
    },
    docCameraAutoContainerMobile:{
      marginBottom: "24px"
    },
    imageTop: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      flexDirection: "column",
    },
    imageLine: {
      flexGrow: 1,
      height: "1px",
      backgroundColor: "rgba(100, 116, 139,0.2)",
      margin: "0 10px",
    },
    myChat: {
      textAlign: "right",
      marginRight: "12px",
      marginTop: "6px",
      flexShrink: 0,
      [theme.breakpoints.down(950)]: {
        marginRight: "12px"
      },
    },
    othersChat: {
      marginLeft: "12px",
      marginTop: "6px",
      flexShrink: 0,
      [theme.breakpoints.down(950)]: {
        marginLeft: "12px"
      },
    },
    chatDetailBox: {
      width: '100%',
      display: 'block',
      marginBottom: '2px',
      marginTop: '10px',
  },
    chatDetailBoxLast: {
      // On mobile the send bar is `position: fixed` and floats over the last
      // message, so give the very last message extra clearance to sit above it.
      [theme.breakpoints.down(950)]: {
        marginBottom: "50px",
      },
    },
    singleConversation1: {
      display: "flex",
      position: "relative",
      alignItems: "center",
    },
    singleConversation1myChat: {
      display: "flex",
      justifyContent: "flex-end",
      position: "relative",
      alignItems: "center",
    },
    singleConversation1Text: {
      maxWidth: "72%",
      width: "auto",
      padding: "10px 14px",
      borderRadius: "20px 20px 20px 6px",
      background: "#E9E9EB",
      color: "#111827",
      marginLeft: "0px",
      lineHeight: 1.4,
      wordBreak: "break-word"
    },
    singleConversation1TextmyChat: {
      maxWidth: "72%",
      width: "auto",
      padding: "10px 14px",
      borderRadius: "20px 20px 6px 20px",
      background: "#007AFF",
      color: "#FFFFFF",
      marginRight: "0px",
      lineHeight: 1.4,
      wordBreak: "break-word",
    },
    emojiOnlyMessage: {
      fontSize: "34px",
      lineHeight: 1.2,
      fontFamily: '"Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif',
      paddingTop: "6px",
      paddingBottom: "6px",
    },
    imageOuter: {
      marginTop: "auto",
    },
    delieveredTime: {
      marginTop: "10px",
      fontFamily: "Inter",
      fontWeight: 400,
      color: "#64748B",
      fontSize: "11px",
    },
    reactionTriggerBtn: {
      height: "20px",
      width: "20px",
      marginRight: "6px",
      padding: 0,
      color: "#64748B",
      background: "#fff",
      border: "1px solid #E2E8F0",
      "&:hover": {
        background: "#F8FAFC",
      },
    },
    reactionTriggerBtnLeft: {
      height: "20px",
      width: "20px",
      marginLeft: "6px",
      padding: 0,
      color: "#64748B",
      background: "#fff",
      border: "1px solid #E2E8F0",
      "&:hover": {
        background: "#F8FAFC",
      },
    },
    reactionPickerContainer: {
      display: "flex",
      alignItems: "center",
      padding: "5px 8px",
      gap: "2px",
      background: "#fff",
      borderRadius: "999px",
      border: "1px solid rgba(255,255,255,0.12)",
      boxShadow: "0 10px 24px rgba(0,0,0,0.28)",
    },
    reactionOptionBtn: {
      width: "34px",
      height: "34px",
      fontSize: "21px",
      padding: 0,
      borderRadius: "50%",
      transition: "transform 0.15s ease",
      "&:hover": {
        transform: "scale(1.16)",
        backgroundColor: "rgba(255,255,255,0.12)",
      },
    },
    reactionPlus: {
      color: "#D1D5DB",
      fontSize: "24px",
      lineHeight: 1,
      fontWeight: 400,
      marginLeft: "4px",
      marginRight: "6px",
      userSelect: "none",
    },
    reactionBadge: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "1px 7px",
      borderRadius: "999px",
      border: "1px solid #E2E8F0",
      background: "#FFFFFF",
      fontSize: "14px",
      width: "fit-content",
      position: "absolute",
      top: "27px",
      zIndex: 2,
      boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
    },
    reactionBadgeReceiver: {
      left: "26px",
    },
    reactionBadgeSender: {
      right: "0px",
    },
    contactsCard: {
      width: "50%",
      position: "absolute",
      zIndex: 1000,
      maxHeight: "400px",
      overflowY: "auto",
    },
    popOverPaper: {
      padding: "4px 4px 2px 4px",
      borderRadius: "8px",
      border: "1px solid #E2E8F0",
      minWidth: "192px",
      background: "#FFF",
       boxShadow:
      "0px 2px 4px rgba(0,0,0,0.06), -3px 5px 20px rgba(0,0,0,-0.88)"
    },
    folderList: {
      "&:hover": {
        background: "black",
        color: "white",
        borderRadius: "10px",
      },
    },
    teammadeModalBox: {
      position: "relative",
      backgroundColor: "#fff",
      padding: "50px 80px",
      width: "80%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "0px 0px 24px 0",
      [theme.breakpoints.down(950)]: {
        width: "96%",
        padding: "12px",
        height: "80%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      },
    },
    
    editModal:{
      position: "relative",
      backgroundColor: "#fff",
      padding: "50px 80px",
      width: "45%",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "0px 0px 24px 0",
      [theme.breakpoints.down(950)]: {
        width: "96%",
        padding: "12px",
        height: "40%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      },
    },
    teammateBox: {
      display: "flex",
      flexWrap: "wrap",
      padding:"40px 0"
      // justifyContent:'space-between'
    },
    infoContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "90%",
      paddingTop: "25px",
      [theme.breakpoints.down(1150)]: {
        flexWrap: "wrap",
        gap: "12px",
      },
      [theme.breakpoints.down(950)]: {
        flexDirection: "column",
        alignItems: "start",
      },
    },
    infoSubContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: "10px",
    },
    infoLogoContainer: {
      width: "36px",
      height: "36px",
      background: "#000",
      borderRadius: "50%",
      color: "#fff",
      paddingTop: "5px",
      "&svg": {
        fontSize: "16px",
      }
    },
    // Mobile Attachment Icons - At Bottom
    mobileAttachmentIcons: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      paddingLeft: "8px",
      // paddingTop: "8px",
      paddingBottom: "8px",
      marginTop: "-15px",
      width: "100%",
      boxSizing: "border-box",
      maxWidth: "100%",
      overflowX: "hidden",
      [theme.breakpoints.up(950)]: {
        display: "none",
        
      },
    },
    mobileActionButton: {
      padding: "4px",
      minWidth: "auto",
      "&:hover": {
        backgroundColor: "transparent",
      },
    },
    mobileActionIcon: {
      width: "20px",
      height: "20px",
    },
    mobileVariablesContainer: {
      display: "flex",
      alignItems: "center",
    },
    topBarContainer: {
      width: "100%",
      backgroundColor: "#fff",
      padding: "10px 16px",
      display: "flex",
      alignItems: "center",
      borderBottom: '1px solid #000',
      justifyContent: "space-between",
      position:'absolute',
      zIndex: 1000,
      paddingTop:'36px',
      // On mobile, pin this to the viewport (not just its scrolling
      // container) so it stays visible — matching WhatsApp — instead of
      // scrolling away when the on-screen keyboard opens and the browser
      // auto-scrolls the focused input into view. `top` is overridden inline
      // per-render to sit just below AppLayout's own fixed mobile app bar
      // (NavigationMenuMobile) instead of underneath it.
      [theme.breakpoints.down(950)]: {
        position: 'fixed',
        left: 0,
        right: 0,
      },
    },
    
    userRow: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginLeft:"23px"
    },
    
    avatarCircle: {
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      backgroundColor: "#444",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    
    avatarIcon: {
      color: "#fff",
      fontSize: "22px",
    },
    
    phoneText: {
      color: "#000",
      fontSize: "16px",
      fontWeight: 500,
    },
    emptyContainer: {
      height: "100%",
      width: "100%",
      // backgroundColor: "#0f0f0f",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      
    },
    
    emptyContent: {
      textAlign: "center",
      color: "#000",
    },
    
    emptyIconCircle: {
      width: 70,
      height: 70,
      borderRadius: "50%",
      backgroundColor: "#FFC629",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto 20px auto",
    },
    
    emptyIcon: {
      fontSize: 30,
      color: "#000",
    },
    
    emptyTitle: {
      fontSize: 18,
      fontWeight: 600,
      marginBottom: 8,
    },
    
    emptySubtitle: {
      fontSize: 14,
      color: "#aaa",
    },
    menuPaper: {
      backgroundColor: "#FFC629",
      color: "#000000",
      borderRadius: 10,
      minWidth: 200,
      marginTop: 6,
    },
    chatActionMenuItem: {
      display: "flex",
      alignItems: "center",
      gap: "10px",
      minHeight: "44px",
      "&:hover": {
        backgroundColor: "rgba(0, 0, 0, 0.08)",
      },
    },
    chatActionMenuIcon: {
      fontSize: "20px",
      color: "#000",
    },
    chatActionMenuText: {
      fontFamily: "Inter",
      fontSize: "15px",
      fontWeight: 500,
      color: "#000",
    },
    
    deleteItem: {
      color: "#ff4d4f",
    },
  });

const StyledMenuItem = withStyles((theme) => ({}))(MenuItem);

export default withStyles(styles)(Messages);
// Customizable Area End
